import { Typography } from "PFComponents/typography";
import { SkillImportance } from "PFTypes/skills_framework";
import React from "react";
import { useTranslation } from "react-i18next";

import pageCss from "../../skills_frameworks_edit_page.module.scss";
import { SkillsImportanceSubsection } from "./skills_importance_subsection";

export const SkillsSection = (): JSX.Element => {
  const { t } = useTranslation("skillsFrameworks", { keyPrefix: "edit" });

  return (
    <>
      <Typography variant="h4" className={pageCss.sectionTitle}>
        {t("skills")}
      </Typography>
      <SkillsImportanceSubsection skillsSectionName="essential" importance={SkillImportance.Essential} />
      <SkillsImportanceSubsection skillsSectionName="supporting" importance={SkillImportance.Supporting} />
    </>
  );
};
